module.exports = __webpack_public_path__ + "static/media/healthcare_doc_slider_phone1.b8d94ca1.png";